import { useRuntimeTranslation } from "../../hooks/useLoadI18nNamespaces";
import { LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES } from "../../methods/getRouteLocalizationNamespaces";

const useLcvRouteLandingTranslation = () => useRuntimeTranslation(LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES);

export default useLcvRouteLandingTranslation;
